import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { TasksService } from 'src/services/tasks.service';
import { SprintService } from '../../../services/sprintSheet.service';
import { NotificationService } from 'src/services/notification.service';
import { AppService } from 'src/app/app.service';
import { NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import * as moment from 'moment';
import { Subject } from 'rxjs';
declare var $;

@Component({
  selector: 'app-list',
  templateUrl: './lists.component.html',
  styleUrls: ['./lists.component.css'],
})
export class ListsComponent implements OnInit {
  public counts: any = "";
  public ParamId = null;
  public boxToggle: boolean = false;
  public isTaskAdded: boolean = false;
  public taskList: any = [];
  public selectedAssignee: any = "";
  public taskDetail: any;
  public taskDate: any;
  public taskStartDate: any;
  public totalCount: number = 0;
  public loginId: number = 0;
  public UserId: number = 0;
  public loginUser: any = "";
  
  // Task properties
  public title: any = '';
  public dueDate: any;
  public addDate: any;
  
  // Task log properties
  public taskId: number = 0;
  public logDatepicker: NgbDateStruct;
  public taskDateLog: any;
  public actualhours: number = 0;
  public logComment: any = '';
  
  // Datatable
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  @ViewChildren(DataTableDirective) dtElements: QueryList<DataTableDirective>;

  public pageNumber = 1;
  public pageSize = 25;
  public sortOrder = "desc";
  public sortBy = "DateAdded";
  
  public toDayDate = moment().format('MM/DD/YYYY');
  public year: any = moment().format('YYYY');
  public today1: any;

  constructor(
    private appService: AppService,
    private tasksService: TasksService,
    private sprintService: SprintService,
    private noti: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
    private calendar: NgbCalendar
  ) { }

  ngOnInit() {
    this.appService.headerTitle.emit({
      data: "SprintSheet"
    });
    
    this.loginUser = JSON.parse(localStorage.getItem('user'));
    if (this.loginUser.accessLevel == 'super_admin' || this.loginUser.accessLevel == 'admin') {
      this.loginId = 0;
      this.UserId = this.loginUser.userId;
    } else {
      this.loginId = this.loginUser.userId;
    }
    
    this.ParamId = this.route.snapshot.queryParams.id;
    this.tasksCounts();

    if (!!this.ParamId) {
      // Handle param logic if needed
    } else {
      if (this.loginUser.accessLevel != 'super_admin') {
        this.selectedAssignee = this.loginUser;
      }
    }

    this.today1 = moment().format('YYYY-MM-DD');

    $('[data-toggle="tooltip"]').tooltip();
    $(".list-inner-wrapper").click((e) => {
      $(this).addClass("list-selected");
    });
    
    this.getAllSprints();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  tasksCounts() {
    this.tasksService.getTasksCounts(this.loginId).subscribe(response => {
      if (response.status == "ok") {
        this.counts = response.data;
      }
    }, error => {
      if (error.status == 401) { }
    });
  }

  getAllSprints() {
    this.dtOptions = {
      pageLength: this.pageSize,
      dom: 'rtlp',
      "columnDefs": [
        { "targets": 0, "orderable": false },
      ],
      processing: false,
      serverSide: true,
      ajax: (dTParameters: any, callback) => {
        this.pageSize = dTParameters['length'];
        this.pageNumber = dTParameters['start'] / this.pageSize + 1;
        this.sprintService.getSprintList(this.pageNumber, this.pageSize, this.sortBy, this.sortOrder, this.loginId).subscribe(response => {
          if (response != null) {
            if (response.status == "ok") {
              this.taskList = response.data.value;
              $(".custom-loader").css("display", "none");
              
              if (response.data.value.length > 0) {
                this.totalCount = response.data.value[0].totalRecords;
              } else {
                this.totalCount = 0;
              }
              
              if (this.taskList.length != 0) {
                setTimeout(() => {
                  $(".dataTables_empty").css("display", "none");
                }, 200);
              }
              
              callback({
                recordsTotal: this.totalCount,
                recordsFiltered: this.totalCount,
                data: []
              });
            }
          }
        }, error => {
          if (error.status == 401) { }
        });
      },
      columns: [
        { "data": 'dateAdded', "orderable": false },
      ]
    };
  }

  closeTaskToggle() {
    $('.slider-log').addClass('close-b');
    $(".slider-log-wrapper").height(0);
    this.isTaskAdded = false;
    this.boxToggle = false;
    this.taskId = 0;
    this.resetTaskForm();
  }

  resetTaskForm() {
    this.taskId = 0;
    this.title = '';
    this.taskDate = null;
    this.taskStartDate = null;
    this.dueDate = null;
    this.addDate = null;
  }

  resetLogForm() {
    this.logComment = '';
    this.actualhours = 0;
    this.logDatepicker = this.calendar.getToday();
    this.taskDateLog = moment().year(this.logDatepicker.year).month(this.logDatepicker.month - 1).date(this.logDatepicker.day).format();
  }

  addTask() {
    $(".btn-submit").prop('disabled', true);
    let isValid = this.validate();
    
    if (isValid) {
      var taskObj = {
        Name: this.title.trim(),
        Status: "null",
        Level: "null",
        EndDate: new Date(this.taskDate),
        StartDate: this.taskStartDate == null ? new Date() : new Date(this.taskStartDate),
      };

      this.sprintService.addTask(taskObj).subscribe(res => {
        if (res.status == "ok") {
          this.taskId = res.data.id;
          this.noti.notification("Success", "Sprint Added Successfully", "success");
          this.rerender(0);
          this.showTaskDetails(res.data);
          this.isTaskAdded = true;
        }
      }, error => {
        if (error.status == 401) { }
      });
    } else {
      $(".btn-submit").prop('disabled', false);
    }
  }

  updateTask() {
    $(".btn-submit").prop('disabled', true);
    let isValid = this.validate();
    
    if (isValid) {
      var taskObj = {
        id: this.taskId,
        Name: this.title.trim(),
        Status: "null",
        Level: "null",
        EndDate: new Date(this.taskDate),
        StartDate: new Date(this.taskStartDate),
      };

      this.tasksService.putSprint(taskObj).subscribe(res => {
        if (res.status == "ok") {
          this.taskId = res.data.id;
          this.noti.notification("Success", "Sprint Updated Successfully", "success");
          this.rerender(0);
          this.showTaskDetails(res.data);
          this.isTaskAdded = true;
        }
      }, error => {
        if (error.status == 401) { }
      });
    } else {
      $(".btn-submit").prop('disabled', false);
    }
  }

  showTaskDetails(data) {
    this.addTaskToggle();
    $('.slider-log').addClass('close-b');
    $(".slider-log-wrapper").height(0);
    $("html, body").animate({ scrollTop: 0 }, "slow");
    
    this.taskId = data.id;
    this.taskDetail = data;
    this.title = data.name;
    this.isTaskAdded = true;
    this.taskStartDate = data.startDate;
    this.taskDate = data.endDate;
    
    let yearT: number = moment(data.endDate).get('year');
    let monthT: number = moment(data.endDate).get('month') + 1;
    let dayT: number = moment(data.endDate).get('date');
    this.dueDate = { year: yearT, month: monthT, day: dayT };
    
    let yearT1: number = moment(data.startDate).get('year');
    let monthT1: number = moment(data.startDate).get('month') + 1;
    let dayT1: number = moment(data.startDate).get('date');
    this.addDate = { year: yearT1, month: monthT1, day: dayT1 };

    $(".btn-submit").prop('disabled', false);
  }

  deleteComfirm() {
    $("#deleteModal").modal("show");
  }

  deleteTask() {
    $(".btn-submit").prop('disabled', true);
    this.tasksService.deleteTask(this.taskId).subscribe(res => {
      if (res.status == "ok") {
        $(".btn-submit").prop('disabled', false);
        this.noti.notification("Success", "Task Deleted Successfully", "success");
        this.closeTaskToggle();
        this.rerender(0);
      } else {
        $(".btn-submit").prop('disabled', false);
        this.noti.notification("Error", "Task not Deleted", "danger");
      }
    }, error => {
      if (error.status == 401) { }
    });
    $("#deleteModal").modal("hide");
  }

  onDateSelect(event) {
    this.taskDate = moment().year(event.year).month(event.month - 1).date(event.day).format();
  }

  onStartDateSelect(event) {
    this.taskStartDate = moment().year(event.year).month(event.month - 1).date(event.day).format();
  }

  addTaskLog() {
    $(".btn-submit").prop('disabled', true);

    this.taskDateLog = moment().year(this.logDatepicker.year)
      .month(this.logDatepicker.month - 1)
      .date(this.logDatepicker.day)
      .format();

    let logObj = {
      TaskId: this.taskId,
      ProjectId: this.taskDetail.projectId,
      UserId: this.loginUser.userId,
      Description: this.logComment.trim(),
      ActualHours: this.actualhours,
      DateAdded: new Date(this.taskDateLog),
      DateUpdated: new Date()
    };

    if (
      logObj.TaskId === undefined ||
      logObj.ProjectId === undefined ||
      logObj.UserId === undefined ||
      logObj.Description === '' ||
      logObj.ActualHours === undefined ||
      logObj.DateAdded === undefined
    ) {
      this.noti.notification("Error", "Some fields are missing or invalid", "danger");
      this.resetLogForm();
      $(".btn-submit").prop('disabled', false);
      return;
    }

    this.tasksService.addTaskLog(logObj).subscribe(res => {
      if (res.status === "ok") {
        this.noti.notification("Success", "Task Log Added Successfully", "success");
        this.taskDetail.logsItems.push(res.data);
        this.taskDetail.logsItems.sort(function (a, b) {
          return (a.dateAdded > b.dateAdded) ? -1 : (a.dateAdded < b.dateAdded) ? 1 : 0;
        });
        this.resetLogForm();
      }
      $(".btn-submit").prop('disabled', false);
    }, error => {
      if (error.status === 401) {
        this.noti.notification("Error", "Unauthorized", "error");
      }
      $(".btn-submit").prop('disabled', false);
    });
  }

  addTaskToggle() {
    if (!this.boxToggle) {
      this.boxToggle = true;
      this.isTaskAdded = false;
    } else {
      this.isTaskAdded = false;
      this.taskId = 0;
      $('.slider-log').addClass('close-b');
      $(".slider-log-wrapper").height(0);
    }
    this.resetTaskForm();
  }

  onDateSelectLog(event) {
    this.taskDateLog = moment().year(event.year).month(event.month - 1).date(event.day).format();
  }

  validate() {
    if (this.title.length < 4) {
      this.noti.notification("Error", "Please select title atleast 5 characters", "danger");
      return false;
    }
    return true;
  }

  validateLog() {
    if (this.logComment.length < 3) {
      this.noti.notification("Error", "Please write comment atleast 3 characters", "danger");
      return false;
    }
    if ((!this.actualhours) || (this.actualhours == null)) {
      this.noti.notification("Error", "Please enter actual hours.", "danger");
      return false;
    }
    return true;
  }

  rerender(index: number): void {
    this.dtElements.toArray()[index].dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }
}